// let flktyInstances = []; // Array to store all Flickity instances

// function initFlickity() {
//   // Destroy any existing instances first
//   destroyFlickity();

//   // Initialize product comparison sliders
//   const comparisonSliders = document.querySelectorAll('.product-comparison-slider');
//   comparisonSliders.forEach(elem => {
//     if (elem) {
//       const flkty = new Flickity(elem, {
//         adaptiveHeight: true,
//         avoidReflow: true,
//         pageDots: false,
//         cellAlign: "left",
//         wrapAround: false,
//       });
//       flktyInstances.push(flkty);
//     }
//   });

//   // Initialize info container sliders (only if more than 2 slides)
//   const infoSliders = document.querySelectorAll('.product-comparison__info-container--slider.small--hide');
//   infoSliders.forEach(elem => {
//     if (elem) {
//       const slides = elem.querySelectorAll('.product-comparison__item-container'); // Adjust selector if needed
      
//       // Only initialize if more than 2 slides
//       if (slides.length > 2) {
//         const flkty = new Flickity(elem, {
//           adaptiveHeight: true,
//           avoidReflow: true,
//           pageDots: false,
//           cellAlign: "left",
//           wrapAround: false,
//           arrowShape: "M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z",
//           // Add any additional options you want for these sliders
//           contain: true,
//           groupCells: true,
//         });
//         flktyInstances.push(flkty);
//       } else {
//         // If 2 or fewer slides, ensure the element has proper styling for non-slider display
//         elem.classList.add('no-slider-needed');
//       }
//     }
//   });
// }

// function destroyFlickity() {
//   // Destroy all instances
//   flktyInstances.forEach(instance => {
//     if (instance) {
//       instance.destroy();
//     }
//   });
//   flktyInstances = []; // Clear the array
  
//   // Remove any no-slider-needed classes that might have been added
//   document.querySelectorAll('.product-comparison__info-container--slider.no-slider-needed')
//     .forEach(el => el.classList.remove('no-slider-needed'));
// }

// document.addEventListener('DOMContentLoaded', () => {
//   initFlickity();

//   let resizeTimeout;
//   window.addEventListener('resize', () => {
//     clearTimeout(resizeTimeout);
//     resizeTimeout = setTimeout(() => {
//       destroyFlickity();
//       initFlickity();
//     }, 300); // debounce for performance
//   });
// });

let flktyInstances = [];

function initFlickity(savedIndexes = {}) {
  destroyFlickity();

  const comparisonSliders = document.querySelectorAll('.product-comparison-slider');
  comparisonSliders.forEach((elem, i) => {
    if (elem) {
      const flkty = new Flickity(elem, {
        adaptiveHeight: true,
        avoidReflow: true,
        pageDots: false,
        cellAlign: "left",
        wrapAround: false,
      });

      // Restore previous index if available
      if (savedIndexes[elem.dataset.flickityId] !== undefined) {
        flkty.select(savedIndexes[elem.dataset.flickityId], false, true);
      }

      flktyInstances.push(flkty);
    }
  });

  const infoSliders = document.querySelectorAll('.product-comparison__info-container--slider.small--hide');
  infoSliders.forEach((elem, i) => {
    if (elem) {
      const slides = elem.querySelectorAll('.product-comparison__item-container');
      if (slides.length > 2) {
        const flkty = new Flickity(elem, {
          adaptiveHeight: true,
          avoidReflow: true,
          pageDots: false,
          cellAlign: "left",
          wrapAround: false,
          arrowShape: "M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z",
          contain: true,
          groupCells: true,
        });

        if (savedIndexes[elem.dataset.flickityId] !== undefined) {
          flkty.select(savedIndexes[elem.dataset.flickityId], false, true);
        }

        flktyInstances.push(flkty);
      } else {
        elem.classList.add('no-slider-needed');
      }
    }
  });
}

function destroyFlickity() {
  flktyInstances.forEach(instance => {
    if (instance) {
      instance.destroy();
    }
  });
  flktyInstances = [];

  document.querySelectorAll('.product-comparison__info-container--slider.no-slider-needed')
    .forEach(el => el.classList.remove('no-slider-needed'));
}

document.addEventListener('DOMContentLoaded', () => {
  initFlickity();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Save current indexes before destroying
      const savedIndexes = {};
      flktyInstances.forEach(flkty => {
        if (flkty && flkty.element) {
          // unique ID per element (data attribute works)
          if (!flkty.element.dataset.flickityId) {
            flkty.element.dataset.flickityId = Math.random().toString(36).substr(2, 9);
          }
          savedIndexes[flkty.element.dataset.flickityId] = flkty.selectedIndex;
        }
      });

      destroyFlickity();
      initFlickity(savedIndexes);
    }, 300);
  });
});
